import { dynamicPrecision } from "common/graphs/Table/TableRenders";

export const RATE_PRECISIONS = [
  [/*below*/ 10, 3 /*digits*/],
  [/*below*/ 100, 2 /*digits*/],
  [/*below*/ 1000, 1 /*digits*/],
  // Defaults to 0 digits
];

const scaledValueAndUnit = value =>
  value >= 1_000_000 ? {value: value / 1_000_000, unit: 'T'} :
  value >= 1_000 ? {value: value / 1_000, unit: 'G'} :
  value >= 1 ? {value, unit: 'M'} :
  value === 0 ? {value, unit: null} : 
  {value: value * 1000, unit: 'K'}

const mayBeNumberOrNA = (parse) => (value, ...args) =>
  value === undefined || value === null || value === "n/a" ? "n/a" :
  parse(Number(value), ...args);

export const renderLimitFromMbps = mayBeNumberOrNA( (value) =>
    value === 0 ? "0" :
    (({value, unit}) => dynamicPrecision(value, RATE_PRECISIONS, true, "trunc") + unit )(
      scaledValueAndUnit(value)
    )
  )
